/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/idealForm.scss';

import {ChangeFunction, Loader, preventDefault, remToPx} from '@dvrd/dvr-controls';
import {IdealBankElement} from '@stripe/react-stripe-js';
import React, {KeyboardEventHandler, MouseEventHandler} from 'react';
import {BolmateButton, BolmateInput} from "../../controls";
import {IdealErrors, ResetErrorHandler} from "../../../util/interfaces";
import Ideal from "../../misc/ideal";

const IDEAL_ELEMENT_OPTIONS = {
    // Custom styling can be passed to options when creating an Element
    style: {
        base: {
            padding: Math.round(remToPx(0.5)) + 'px',
            color: '#2A435F',
            fontSize: remToPx(1) + 'px',
            '::placeholder': {
                color: '#aab7c4'
            },
        },
    },
};


interface Props {
    onChangeName: ChangeFunction<string>;
    onChangeEmail: ChangeFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onResetError: ResetErrorHandler<IdealErrors>;
    name: string;
    email: string;
    loading: boolean;
    errors: IdealErrors;
}

export default function IdealForm(props: Props) {
    const {name, email, onChangeEmail, onChangeName, loading, onSubmit, errors, onResetError} = props;
    return (
        <div className='ideal-form-container'>
            <form onSubmit={preventDefault} className='ideal-form'>
                <Loader active={loading}/>
                <div className='header-container'>
                    <Ideal width='3.2rem' height='3.2rem' className='ideal-logo'/>
                    <label className='form-title'>Automatisch betalen met iDeal</label>
                </div>
                <div className='body-container'>
                    <p className='explanation'>Er wordt ter bevestiging &euro;0,01 van je rekening afgeschreven. Zodra
                        je bankrekening bevestigd is wordt dit direct teruggestord.</p>
                    <div className='bank-select'>
                        <label className='bank-label'>Bank *</label>
                        <div className='ideal-bank'>
                            <IdealBankElement options={IDEAL_ELEMENT_OPTIONS}/>
                        </div>
                    </div>
                    <BolmateInput onChange={onChangeName} value={name} label='Naam rekeninghouder *'
                                  onEnter={onSubmit} onFocus={onResetError('name')} error={errors.name}/>
                    <BolmateInput onChange={onChangeEmail} value={email} label='E-mailadres *' error={errors.email}
                                  inputProps={{type: 'email'}} onEnter={onSubmit} onFocus={onResetError('email')}/>
                    <label className='disclaimer'>Door ondertekening van dit formulier geeft u toestemming aan Bolmate
                        B.V. en Stripe standaard Europese incasso-opdrachten te sturen naar uw bank om een bedrag van uw
                        rekening af te schrijven en aan uw bank om een bedrag van uw rekening af te schrijven
                        overeenkomstig deze opdracht. Als u het niet eens bent met deze afschrijving kunt u deze laten
                        terugboeken. Een dergelijk verzoek moet binnen acht weken na de datum van afschrijving worden
                        ingediend. Vraag uw bank naar de voorwaarden.</label>
                    <BolmateButton onClick={onSubmit} label='Accepteren'
                                   disabled={!name.length || !email.length || loading} className='submit'/>
                </div>
            </form>
        </div>
    )
};